import { InspectionCache, InspectionStatus } from "../types/ownerPortfolio.types";

const POLLING_STATUSES: InspectionStatus[] = ["queued", "searching"];

export function shouldPollInspection(status: InspectionStatus | null): boolean {
  if (!status) {
    return false;
  }

  return POLLING_STATUSES.includes(status);
}

export function hasInspectionReport(cache: InspectionCache | null): boolean {
  return cache?.status === "ready" && cache.report !== null;
}

export function shouldShowInspectionMessage(cache: InspectionCache | null): boolean {
  if (!cache?.message) {
    return false;
  }

  return !shouldPollInspection(cache.status);
}
